import createAPI from '../axios'

// 顶岗实习相关 API
const postPracticeManage = {
    //人员角色
    personalRole: {
        queryList: config => createAPI('/postPracticeManage/personalRole/queryList', 'post', config),

        initCombo: config => createAPI('/postPracticeManage/personalRole/initCombo', 'post', config),

        save: config => createAPI('/postPracticeManage/personalRole/save', 'post', config),

        del: config => createAPI('/postPracticeManage/personalRole/del', 'post', config),

        queryStuList: config => createAPI('/postPracticeManage/personalRole/queryStuList', 'post', config),

        loadClass: config => createAPI('/postPracticeManage/personalRole/loadClass', 'post', config),

        saveStu: config => createAPI('/postPracticeManage/personalRole/saveStu', 'post', config),

        queryInsructStu: config => createAPI('/postPracticeManage/personalRole/queryInsructStu', 'post', config),

        delInsructStu: config => createAPI('/postPracticeManage/personalRole/delInsructStu', 'post', config),

        initClass: config => createAPI('/postPracticeManage/personalRole/initClass', 'post', config),
    },
    //实习申请
    practiceApply: {
        queryList: config => createAPI('/postPracticeManage/practiceApply/queryList', 'post', config),

        initCombo: config => createAPI('/postPracticeManage/practiceApply/initCombo', 'post', config),

        save: config => createAPI('/postPracticeManage/practiceApply/save', 'post', config),

        batchImport: config => createAPI('/postPracticeManage/practiceApply/batchImport', 'post', config),

        del: config => createAPI('/postPracticeManage/practiceApply/del', 'post', config),
    },
    //学生实习信息
    stuPractice: {
        loadPracticeInfo: config => createAPI('/postPracticeManage/stuPractice/loadPracticeInfo', 'post', config),

        loadNotification: config => createAPI('/postPracticeManage/stuPractice/loadNotification', 'post', config),

        applySave: config => createAPI('/postPracticeManage/stuPractice/applySave', 'post', config),

        loadApplyInfo: config => createAPI('/postPracticeManage/stuPractice/loadApplyInfo', 'post', config),

        loadChangeInfo: config => createAPI('/postPracticeManage/stuPractice/loadChangeInfo', 'post', config),

        changeSave: config => createAPI('/postPracticeManage/stuPractice/changeSave', 'post', config),

        inApply: config => createAPI('/postPracticeManage/stuPractice/inApply', 'post', config),

        inChange: config => createAPI('/postPracticeManage/stuPractice/inChange', 'post', config),

        changeDel: config => createAPI('/postPracticeManage/stuPractice/changeDel', 'post', config),

        applyDel: config => createAPI('/postPracticeManage/stuPractice/applyDel', 'post', config),

        completeSave: config => createAPI('/postPracticeManage/stuPractice/completeSave', 'post', config),

        loadFile: config => createAPI('/postPracticeManage/stuPractice/loadFile', 'post', config),

        loadSummary: config => createAPI('/postPracticeManage/stuPractice/loadSummary', 'post', config),

        loadGuidance: config => createAPI('/postPracticeManage/stuPractice/loadGuidance', 'post', config),

        newApply: config => createAPI('/postPracticeManage/stuPractice/newApply', 'post', config),

        loadHomecomingInfo: config => createAPI('/postPracticeManage/stuPractice/loadHomecomingInfo', 'post', config),

        loadReportList: config => createAPI('/postPracticeManage/stuPractice/loadReportList', 'post', config),

        fileDelete: config => createAPI('/postPracticeManage/stuPractice/fileDelete', 'post', config),

        uploadReport: config => createAPI('/postPracticeManage/stuPractice/uploadReport', 'post', config),

        download: config => createAPI('/postPracticeManage/stuPractice/download', 'post', config),

        delFile: config => createAPI('/postPracticeManage/stuPractice/delFile', 'post', config),

        queryAuditFlow: config => createAPI('/postPracticeManage/stuPractice/queryAuditFlow', 'post', config),
    },
    //自主联系申请审核
    autonomouslyApply: {
        queryList: config => createAPI('/postPracticeManage/autonomouslyApply/queryList', 'post', config),

        initData: config => createAPI('/postPracticeManage/autonomouslyApply/initData', 'post', config),

        updateAuditState: config => createAPI('/postPracticeManage/autonomouslyApply/updateAuditState', 'post', config),
    },
    //实习变更申请审核
    practiceChange: {
        queryList: config => createAPI('/postPracticeManage/practiceChange/queryList', 'post', config),

        initData: config => createAPI('/postPracticeManage/practiceChange/initData', 'post', config),

        updateAuditState: config => createAPI('/postPracticeManage/practiceChange/updateAuditState', 'post', config),

        queryAuditFlow: config => createAPI('/postPracticeManage/practiceChange/queryAuditFlow', 'post', config),
    },
    //通知公告
    notification: {
        queryList: config => createAPI('/postPracticeManage/notification/queryList', 'post', config),

        initData: config => createAPI('/postPracticeManage/notification/initData', 'post', config),

        saveRec: config => createAPI('/postPracticeManage/notification/saveRec', 'post', config),

        delRec: config => createAPI('/postPracticeManage/notification/delRec', 'post', config),
    },
    //实习文件
    practiceFile: {
        loadFileList: config => createAPI('/postPracticeManage/practiceFile/loadFileList', 'post', config),

        initCombo: config => createAPI('/postPracticeManage/practiceFile/initCombo', 'post', config),

        uploadFile: config => createAPI('/postPracticeManage/practiceFile/uploadFile', 'post', config),

        delRec: config => createAPI('/postPracticeManage/practiceFile/delRec', 'post', config),
    },
    //实习周记
    weeklyReport: {
        queryList: config => createAPI('/postPracticeManage/weeklyReport/queryList', 'post', config),

        initCombo: config => createAPI('/postPracticeManage/weeklyReport/initCombo', 'post', config),

        saveScore: config => createAPI('/postPracticeManage/weeklyReport/saveScore', 'post', config),
    },
    //现场指导
    siteInstruction: {
        queryList: config => createAPI('/postPracticeManage/siteInstruction/queryList', 'post', config),

        del: config => createAPI('/postPracticeManage/siteInstruction/del', 'post', config),

        batchExport: config => createAPI('/postPracticeManage/siteInstruction/batchExport', 'post', config),

        exportMobile: config => createAPI('/postPracticeManage/siteInstruction/exportMobile', 'post', config),

        download: config => createAPI('/postPracticeManage/siteInstruction/download', 'post', config),

        delFile: config => createAPI('/postPracticeManage/siteInstruction/delFile', 'post', config),
    },
    //现场指导记录表
    recordTable: {
        loadStuCombo: config => createAPI('/postPracticeManage/recordTable/loadStuCombo', 'post', config),

        loadStuClass: config => createAPI('/postPracticeManage/recordTable/loadStuClass', 'post', config),

        save: config => createAPI('/postPracticeManage/recordTable/save', 'post', config),

        uploadPhoto: config => createAPI('/postPracticeManage/recordTable/uploadPhoto', 'post', config),

        loadPhoto: config => createAPI('/postPracticeManage/recordTable/loadPhoto', 'post', config),

        removePhoto: config => createAPI('/postPracticeManage/recordTable/removePhoto', 'post', config),

        loadRecordTable: config => createAPI('/postPracticeManage/recordTable/loadRecordTable', 'post', config),

        loadStuPost: config => createAPI('/postPracticeManage/recordTable/loadStuPost', 'post', config),

        loadUnitCombo: config => createAPI('/postPracticeManage/recordTable/loadUnitCombo', 'post', config),
    },
    //周记
    summary: {
        summarySave: config => createAPI('/postPracticeManage/summary/summarySave', 'post', config),

        uploadPhoto: config => createAPI('/postPracticeManage/summary/uploadPhoto', 'post', config),

        loadPhoto: config => createAPI('/postPracticeManage/summary/loadPhoto', 'post', config),

        removePhoto: config => createAPI('/postPracticeManage/summary/removePhoto', 'post', config),
    },
    //学生实习记录查询
    stuPracticeInfo: {
        queryList: config => createAPI('/postPracticeManage/stuPracticeInfo/queryList', 'post', config),

        initCombo: config => createAPI('/postPracticeManage/stuPracticeInfo/initCombo', 'post', config),
    },
    completionStatistics:{
        queryList: config => createAPI('/postPracticeManage/completionStatistics/queryList', 'post', config),
    },
    //实习落实情况统计
    practicableStatistics: {
        queryYearList: config => createAPI('/postPracticeManage/practicableStatistics/queryYearList', 'post', config),

        queryList: config => createAPI('/postPracticeManage/practicableStatistics/queryList', 'post', config),
    },
    //走访企业统计
    interviewStatistics: {
        queryList: config => createAPI('/postPracticeManage/interviewStatistics/queryList', 'post', config),

        loadUnitTime: config => createAPI('/postPracticeManage/interviewStatistics/loadUnitTime', 'post', config),

        loadDateTime: config => createAPI('/postPracticeManage/interviewStatistics/loadDateTime', 'post', config),

        loadUnitDetail: config => createAPI('/postPracticeManage/interviewStatistics/loadUnitDetail', 'post', config),

        loadDateDetail: config => createAPI('/postPracticeManage/interviewStatistics/loadDateDetail', 'post', config),
    },
    //学生返校
    homecoming: {
        queryList: config => createAPI('/postPracticeManage/homecoming/queryList', 'post', config),

        initCombo: config => createAPI('/postPracticeManage/homecoming/initCombo', 'post', config),

        del: config => createAPI('/postPracticeManage/homecoming/del', 'post', config),

        loadNotificationList: config => createAPI('/postPracticeManage/homecoming/loadNotificationList', 'post', config),

        saveNotificationRec: config => createAPI('/postPracticeManage/homecoming/saveNotificationRec', 'post', config),

        delNotificationRec: config => createAPI('/postPracticeManage/homecoming/delNotificationRec', 'post', config),
    },
    //返校记录
    homecomingRecord:{
        loadClass: config => createAPI('/postPracticeManage/homecomingRecord/loadClass', 'post', config),

        save: config => createAPI('/postPracticeManage/homecomingRecord/save', 'post', config),

        loadHomecomingInfo: config => createAPI('/postPracticeManage/homecomingRecord/loadHomecomingInfo', 'post', config),

        loadStuAttendance: config => createAPI('/postPracticeManage/homecomingRecord/loadStuAttendance', 'post', config),

        changeAttendanceState: config => createAPI('/postPracticeManage/homecomingRecord/changeAttendanceState', 'post', config),

        uploadPhoto: config => createAPI('/postPracticeManage/homecomingRecord/uploadPhoto', 'post', config),

        removePhoto: config => createAPI('/postPracticeManage/homecomingRecord/removePhoto', 'post', config),

        loadPhoto: config => createAPI('/postPracticeManage/homecomingRecord/loadPhoto', 'post', config),

        loadStuAttendanceInfo: config => createAPI('/postPracticeManage/homecomingRecord/loadStuAttendanceInfo', 'post', config),

        saveModSituation: config => createAPI('/postPracticeManage/homecomingRecord/saveModSituation', 'post', config),

        changeSituation: config => createAPI('/postPracticeManage/homecomingRecord/changeSituation', 'post', config),
    },
    //实习报告
    practiceReport:{
        queryList: config => createAPI('/postPracticeManage/practiceReport/queryList', 'post', config),

        initCombo: config => createAPI('/postPracticeManage/practiceReport/initCombo', 'post', config),

        exportBatch: config => createAPI('/postPracticeManage/practiceReport/exportBatch', 'post', config),
    },
    //报告
    report:{
        loadReportList: config => createAPI('/postPracticeManage/report/loadReportList', 'post', config),

        uploadReport: config => createAPI('/postPracticeManage/report/uploadReport', 'post', config),

        fileDelete: config => createAPI('/postPracticeManage/report/fileDelete', 'post', config),

        loadScoreCombo: config => createAPI('/postPracticeManage/report/loadScoreCombo', 'post', config),

        saveScore: config => createAPI('/postPracticeManage/report/saveScore', 'post', config),

        loadMark: config => createAPI('/postPracticeManage/report/loadMark', 'post', config),
    },
    //学生成绩评定
    scoreEvaluation:{
        queryList: config => createAPI('/postPracticeManage/scoreEvaluation/queryList', 'post', config),

        initCombo: config => createAPI('/postPracticeManage/scoreEvaluation/initCombo', 'post', config),

        loadItem: config => createAPI('/postPracticeManage/scoreEvaluation/loadItem', 'post', config),

        loadStuEvaluateInfo: config => createAPI('/postPracticeManage/scoreEvaluation/loadStuEvaluateInfo', 'post', config),

        saveScore: config => createAPI('/postPracticeManage/scoreEvaluation/saveScore', 'post', config),

        delDetail: config => createAPI('/postPracticeManage/scoreEvaluation/delDetail', 'post', config),

        saveDetail: config => createAPI('/postPracticeManage/scoreEvaluation/saveDetail', 'post', config),

        updRole: config => createAPI('/postPracticeManage/scoreEvaluation/updRole', 'post', config),

        delItem: config => createAPI('/postPracticeManage/scoreEvaluation/delItem', 'post', config),

        saveItem: config => createAPI('/postPracticeManage/scoreEvaluation/saveItem', 'post', config),
    },
    //成绩评定
    stuEvaluation:{
        query: config => createAPI('/postPracticeManage/stuEvaluation/query', 'post', config),
    },

};

export default postPracticeManage;



// WEBPACK FOOTER //
// ./src/api/modules/postPracticeManage.js